<template>
  <main class="modal-main">
    <template v-if="!(isNoProduct || isRemind)">
      <div class="pdd-basestep-main">
        <div class="step-padding">
          <div class='t_999 t_center fs-26'>第 1 步 (共 2 步)</div>
        </div>
        <div class="basestep-title">
          <div class="bt-title"><span class="icon">1</span><span>核对价格信息</span></div>
          <div class="bt-tip t_999">与商品详情页的价格进行对比，若价格不一致，请点击【差价反馈】</div>
        </div>
        <!-- tab条目 -->
        <div class='step-padding mar-top'>
          <div class='step-tab-item'>
            <div class='shrink t_999'>购物平台：</div>
            <div class="step-platform_tag pdd">
              <i class="iconfont icon-pinduoduo"></i><span>拼多多App</span>
            </div>
          </div>
          <div class='step-tab-item guide-coupon' v-if="step1Info.IsCoupon">
            <div class='shrink t_999'>详情页领券：</div>
            <span class='coupon-tag-sure primary'>{{step1Info.CouponAmount}}元券</span>
          </div>
          <div class='step-tab-item guide-price'>
            <div class='shrink t_999'>{{step1Info.IsCoupon ? '券后付款金额' : '付款金额'}}：</div>
            <div class="flex-center">
              <div class='feeback-btn' @click="showDiff({taskID: taskId, dataInfo: step1Info, platform: 2})">差价反馈</div>
              <div>￥{{step1Info.ProductPrice || '-'}}</div>
            </div>
          </div>
          <div class='step-tab-item'>
            <div class='shrink t_999'>收货后返利：</div>
            <div class='flex'>￥{{step1Info.BuyRebatePrice || '-'}}</div>
          </div>
          <div class='step-tab-item' v-if="goodsRemark">
            <div class='shrink t_999'>购物须知</div>
            <div class='flex flex_wrap key-maxwidth'>
              <div class='filter_tag danger' v-for="(item, index) in remarkArr" :key="index">{{item}}</div>
            </div>
          </div>
        </div>
        <div class="basestep-title mar-top">
          <div class="bt-title"><span class="icon">2</span><span>进入购物平台</span></div>
          <div class="gobuy-cnt">
            <span class="t_999">点击右侧按钮，跳转拼多多购买</span>
            <div class="buy-btn" @click="pddBuyNow">立即购买</div>
          </div>
        </div>
      </div>
      <div class='tc_button'>
        <div class='tc_btn shCancelBtn' @click="cancelOrder()">{{ isFreeCard? '取消兑换':'取消购买' }}</div>
        <!-- <template v-if="isFreeCard">
          <div class='tc_btn shCancelBtn' @click="baseModeCancelConvert(true)">取消兑换</div>
        </template>
        <template v-else>
          <div class='tc_btn shCancelBtn' @click="baseModeCancelConvert(false)">取消购买</div>
        </template> -->
        <div class='tc_btn shPrimaryBtn' @click="next">下一步</div>
      </div>
    </template>
    <!-- 无库存显示 -->
    <out-of-stock-popup
       v-if="isNoProduct"
      @formSubmitRemind="formSubmitRemind">
    </out-of-stock-popup>
    <!-- 已加入收藏显示 -->
    <add-collectioned  v-if="isRemind"></add-collectioned>
    <!-- 基础销量模式不需要这个关键词反馈 -->
    <!-- <div :class="{'disabled-action': isCounting}">
      <mt-actionsheet
        :actions="actionsList"
        v-model="sheetVisible">
      </mt-actionsheet>
    </div> -->
    <cancel-order-popup
        :isShow="isShowCancelOrderPopup"
        :isShowChangeKeyWordBtn="isShowChangeKeyWordBtn"
        @changeKeyWord="customChangeKeyWordEvent"
        @confirm="customCancelSaleTaskAccept"
        @close="closeCancelOrderPopup"
      ></cancel-order-popup>
  </main>
</template>

<script>
import feedbackBtnEvent from "@/mixins/feedbackBtnEvent";
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { PddBaseSaleModelOrderStep1InfoGet } from '@/api/detailPage'
import OutOfStockPopup from '@/views/purchaseProcess/children/OutOfStockPopup'
import AddCollectioned from '@/views/purchaseProcess/children/AddCollectioned'
import stepOneMixin from '../../mixins/stepOneMixin'
import cancelOrder from "@/mixins/cancelOrder";

export default {
  mixins: [stepOneMixin, feedbackBtnEvent, cancelOrder],
  data () {
    return {
      taskId: null,
      btnDisabled: true,
      step1Info: {}
    }
  },
  mounted () {
    this.taskId = this.$route.query.taskId
    if (!this.taskId) {
      Toast('无任务id')
      this.$router.go(-1)
      return
    }
    if (String(this.$route.query.isFreeCard) === 'true') {
      this.isFreeCard = true
    }
    this.WAPPicUrl = decodeURI(this.$route.query.wAPPicUrl)
    this.productID = this.$route.query.productId
    this.boxElem = document.querySelector('.prod-popup')
    if (!this.getSoHoInfo) {
      this.fetchOpenShouhuoData(this.fetchData)
    } else {
      this.soHoInfo = this.getSoHoInfo
      if (this.soHoInfo.ConfigCondition) this.configCondition = this.soHoInfo.ConfigCondition.split(',')
      this.handleKeyAndTime(this.fetchData)
    }
  },
  components: {
    OutOfStockPopup,
    AddCollectioned
  },
  methods: {
    // 基础销量数据获取
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.btnDisabled = true
      PddBaseSaleModelOrderStep1InfoGet({ taskID: this.taskId }).then(res => {
        Indicator.close()
        this.btnDisabled = false
        this.step1Info = res
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 商品已加入免单
    changeToFreeCard (infoMsg, isFreeCard) {
      MessageBox({
        title: '提示',
        message: infoMsg,
        showCancelButton: true,
        confirmButtonText: '留在此页',
        cancelButtonText: '返回',
        confirmButtonClass: 't_f23030'
      }).then(action => {
        if (action === 'confirm') {
          this.$router.replace({
            name: 'pddBaseStepOne',
            query: {
              productID: this.productID,
              isFreeCard: isFreeCard
            }
          })
          this.fetchOpenShouhuoData()
        } else {
          this.returnBeforeRoute()
        }
      }).catch(res => {})
    },
    // 返回上一页
    returnBeforeRoute () {
      this.$router.go(-1)
    },
    // 差价反馈
    diffPriceFeedback () {
      this.$router.push({
        name: 'diffPeiceFeedback',
        query: {
          taskID: this.taskId,
          platform: 1
        }
      })
    },
    // 取消兑换/取消购买
    baseModeCancelConvert (value) {
      this.isCancelFreeCard = value
      this.cancelOrder()
    },
    // 立即购买
    pddBuyNow () {
      MessageBox({
        title: '提示',
        message: '前往拼多多购买后，请记得回到平台提交订单哦~',
        showCancelButton: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonText: '先等等',
        confirmButtonText: '去购买',
        confirmButtonClass: 't_f23030'
      }).then(action => {
        if (action === 'confirm') {
          if (this.step1Info.PddSpeciaKeyword) {
            window.location.href = this.step1Info.PddSpeciaKeyword
          } else {
            Toast('链接错误，请稍后再试~')
          }
        }
      })
    },
    // 下一步
    next () {
      if (this.btnDisabled) return
      this.$router.push({
        name: 'pddBaseStepTwo',
        query: {
          readyTaskId: this.taskId
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    let fromRoutes = ['goodsDetail', 'pddBaseStepTwo', 'order', 'diffPeiceFeedback', 'checkPeiceFeedback']
    if (fromRoutes.indexOf(from.name) !== -1 || !from.name) {
      next()
    } else {
      next({ name: 'souhuo' })
    }
  }
}
</script>

<style scoped>
  @import '../../step.scss';
  .pdd-basestep-main{
    width: 100%;
    max-height: 86%;
    background: #f2f2f2;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .basestep-title{
    background: #ffffff;
    padding: 3% 4%;
    box-sizing: border-box;
  }
  .basestep-title .bt-title{
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
  }
  .basestep-title .icon{
    display: inline-block;
    height: 20px;
    width: 20px;
    line-height: 20px;
    text-align: center;
    border: 1px solid;
    border-radius: 50%;
    margin-right: 5px;
    font-weight: 500;
  }
  .basestep-title .bt-tip{
    margin-top: 10px;
    line-height: 20px;
  }
  .flex-center{
    display: flex;
    align-items: center;
  }
  .feeback-btn{
    background: #409EFf;
    color: #fff;
    height: 24px;
    line-height: 24px;
    border-radius: 15px;
    padding: 0 8px;
    box-sizing: border-box;
    margin-right: 5px;
  }
  .step-tab-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    min-height: 28px;
  }
  .step-tab-item:last-child{
    border-bottom: none;
  }
  .gobuy-cnt{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .gobuy-cnt .buy-btn{
    background: #409EFf;
    color: #fff;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    padding: 0 15px;
    box-sizing: border-box;
    cursor: pointer;
  }
</style>
